<template>
  <div class="withdraw md-layout md-alignment-center-center">

    <div class="container-header">
      <div class="container-header__title">{{ i18n.withdraw_withdrawal() }}</div>
    </div>

    <template v-if="view.mode === VIEW_MODES.submit && tokenCodes.length">
      <form
        class="md-layout-item
          md-size-50
          md-medium-size-65
          md-small-size-95
          md-xsmall-size-100"
        @submit.prevent="processTransfer"
      >
        <md-card
          class="container container_40"
          :class="{'grey': colorTron === 'Gray'}"
        >
          <md-progress-bar md-mode="indeterminate" v-if="isPending"/>
          <div
            v-if="!isTron"
            class="withdraw__user-balance text_medium"
          >
            {{
              i18n.lbl_current_balance({
                amount: swimBalance,
                asset: formatToken
              })
            }}
          </div>
          <div
            v-else
            class="withdraw__user-balance text_medium"
          >
            <p class="bold">
              {{
                i18n.lbl_current_balance({
                  amount: greyWhiteTronSum,
                  asset: formatToken
                })
              }}
            </p>
            <p>{{i18n.white_wallet()}}: {{ swimBalance }} {{ formatToken }}</p>
            <p>{{i18n.gray_wallet()}}: {{ greyTronValue }} {{ formatToken }}</p>
          </div>
          <!-- <div class="withdraw__user-balance text_medium" v-if="subWalletBalance">
            {{
              i18n.lbl_sub_current_balance({
                amount: roundCurrency2(subWalletBalance !== undefined ? subWalletBalance.Balance : 0, subWalletBalance.Asset),
                asset: formatToken
              })
            }}
          </div> -->
          <div>
            <p class="withdraw__explanations text_large">
              <template v-if="commissionDescription">
                {{ commissionDescription }}
              </template>
            </p>
            <!-- <div class="widthdraw__subwallet" v-if="subWalletsFormated.length">
              <select-field2
                  class="md-layout-item withdraw__select"
                  :label="i18n.lbl_sub()"
                  :values="subWalletsFormated"
                  v-model="activeSubWallet"
              />
            </div> -->
            <div
              v-if="isTron"
              class="swticher-tron"
            >
              <p>{{ i18n.white_wallet() }}</p>
              <md-switch class="md-primary" v-model="colorTronSwitch"></md-switch>
              <p>{{ i18n.gray_wallet() }}</p>
            </div>
            <div class="md-layout withdraw__flex-wrapper">
              <select-field3
                class="md-layout-item withdraw__select"
                :class="{'grey': colorTron === 'Gray'}"
                :label="i18n.lbl_choose_asset()"
                :values="tokensCodeFormatted"
                v-model="form.tokenCode"
                @change="checkLimit"
              />
              <div class="md-layout-item withdraw__field">
                <input-field
                  class="field__number"
                  :class="{'grey': colorTron === 'Gray'}"
                  v-model.trim="form.amount"
                  :label="i18n.lbl_amount()"
                  @blur="checkLimit(), checkAmount()"
                  name="amount"
                  type="number"
                  title="Amount"
                  align="right"
                  vvValidateOn="change"
                  v-validate="'required|amount'"
                  :errorMessage="
                    errors.first('amount') ||
                    (isLimitExceeded ? i18n.withdraw_error_insufficient_funds() : '') ||
                    (isWithdrawLimitExceeded ? i18n.withdraw_error_maximum_amount({
                      value: maxAmounts[form.tokenCode],
                      asset: formatToken })
                    : '') ||
                    (lessThenMinimumAmount ? i18n.withdraw_error_minimum_amount({
                      value: minAmount,
                      asset: formatToken })
                    : '')"
                />
              </div>
            </div>

            <div
              v-if="form.amount && form.amount > 0"
              class="withdraw__fees-container text_medium"
              :class="{ loading: isFeesLoadPending }"
            >
              <div>{{
                  i18n.fees_percent_fixed({
                    percent: allFees.percent,
                    fixed: allFees.fixed,
                    currency: formatToken
                  })
                }}
              </div>
              <div v-if="isFeesCharged()">{{
                  i18n.fees_will_charged({
                    willCharged: willCharged,
                    currency: formatToken
                  })
                }}
              </div>
            </div>

            <div
              v-if="limitList"
              class="withdraw__fees-container"
              :class="{ loading: isFeesLoadPending }"
            >
              <template v-for="(item, key) in limitList">
                <div v-if="item.period === 'operation' || item.period === 'day'" :key="key">
                  <p></p>
                  <p v-if="item.period === 'operation'">{{
                      i18n.lim_withdrawal_daily_msg1({
                        limit: item.amount_limit,
                        asset: formatToken
                      })
                    }}
                  </p>
                  <p v-if="item.period === 'day'">{{
                      i18n.lim_withdrawal_daily_msg2({
                        limit: item.amount_limit,
                        asset: formatToken
                      })
                    }}
                  </p>
                  <p>{{ i18n.lim_withdrawal_daily_msg3() }}</p>
                </div>
              </template>
            </div>
            <div
              v-for="(value, key) in form.wallets"
            >
              <input-field
                class="md-layout-item"
                :class="{'grey': colorTron === 'Gray'}"
                v-if="key === form.tokenCode && isCryptoToken(form.tokenCode)"
                v-model.trim="form.wallets[key]"
                :autocomplete="false"
                :label="getDirections(WITHDRAW_DIRECTION.external)"
                :name="key"
                :id="key"
                v-validate="`required|${addressRuleFor(key)}`"
                :errorMessage="errors.first(key) || (isTryingToSendToYourself ? i18n.withdraw_error_is_trying_to_send_to_yourself() : '')"
              />
              <input-field
                class="md-layout-item"
                :class="{'grey': colorTron === 'Gray'}"
                v-else-if="form.tokenCode === key"
                v-model.trim="form.direction"
                name="direction"
                :readonly="true"
                :value="getDirections(WITHDRAW_DIRECTION.cashbox)"
                @blur="checkLimit()"
              />
              <span class="danger" v-if="errors.first(key)">{{ errors.first(key) }}</span>
            </div>
          </div>
          <div class="btn-wrap">
            <md-button
              type="submit"
              :disabled="!isCashable"
              class="btn md-primary md-yellow w-100"
            >
              {{ i18n.withdraw_withdraw() }}
            </md-button>
          </div>
        </md-card>
      </form>
    </template>
    <template v-else-if="view.mode === VIEW_MODES.confirm">
      <confirm-withdraw
        :opts="view.opts" :limitList="limitList"
        class="container
          container_40
          md-layout-item
          md-size-50
          md-medium-size-45
          md-small-size-100
          md-xsmall-size-100"
        :isPending="isPending"
        @cancel-click="updateView(VIEW_MODES.submit)"
        @confirm-click="submit"
      />
    </template>
    <template v-if="view.mode === VIEW_MODES.success">
      <md-card
        class="container
          container_40
          withdraw__success-msg
          md-layout-item
          md-size-50
          md-medium-size-45
          md-small-size-100
          md-xsmall-size-100"
        :class="{'grey': colorTron === 'Gray'}"
      >
        <div class="md-title">{{ i18n.withdraw_success() }}</div>
        <div class="withdraw__success-amount">
          {{ swimAmount }} {{ formatToken }}
        </div>
        <div class="btn-wrap space-between margin-top">
          <md-button
            class="btn md-primary w-100"
            @click="updateView(VIEW_MODES.submit, {} , true)"
          >
            {{ i18n.lbl_go_back() }}
          </md-button>
          <md-button
            :to="'/history/index/' + form.tokenCode"
            class="btn md-primary md-yellow w-100"
          >
            {{ i18n.lbl_view_history() }}
          </md-button>
        </div>
      </md-card>
    </template>
    <template v-if="!tokenCodes.length">
      <md-card
        class="container
          container_40
          md-layout-item
          md-size-50
          md-medium-size-65
          md-small-size-95
          md-xsmall-size-100"
      >
        <div class="container__no-data">
          <md-icon class="md-size-4x">credit_card</md-icon>
          <div class="text_large">{{ i18n.withdraw_no_assets() }}</div>
          <div class="text_description text_margin text_medium">{{ i18n.withdraw_no_assets_exp() }}</div>
        </div>
      </md-card>
    </template>
  </div>
</template>

<script>
import formMixin from '@com/mixins/form.mixin'
import debounce from 'lodash/debounce'
import get from 'lodash/get'

import SelectField from '@com/fields/SelectField'
import SelectField2 from '@com/fields/SelectField2'
import SelectField3 from '@com/fields/SelectField3'
import InputField from '@com/fields/InputField'
import ConfirmWithdraw from './Withdrawal.Confirm'

import {mapGetters, mapActions} from 'vuex'
import {vuexTypes} from '@vuex/types'

import {i18n} from '@js/i18n'
import {feeService} from '@api/fees.service'
import {usersService} from '@api/users.service'
import {withdrawService} from '@api/withdraw.service'
import {limitsService} from '@api/limits.service'
import {EventDispatcher} from '@js/events/event_dispatcher'
import {ErrorHandler} from '@js/errors/error_handler'
import {errors} from '@js/errors/factory'
import {CurrencyHelper} from '@js/helpers/currency.helper'
import CurrencyRound from '@com/mixins/currency.round.mixin'

import {DECIMAL_PLACES} from '@utils/math.util'
import {XPAY_NON_VISIBLE_TYPE, ACCOUNT_TYPES} from '@const'
import {transactionType} from '@js/const/limits.const'
import {CRYPTO_CURRENCYS, getTokenNetwork, isNetworkToken, isCryptoToken, formatTokenCode, sortAssetCodes, addressRuleFor} from '@utils/consts'

// import { withdrawUSDTService } from '@api/withdraw_usdt.service'

const VIEW_MODES = {
  submit: 'submit',
  confirm: 'confirm',
  success: 'success'
}

const WITHDRAW_DIRECTION = {
  nothere: 0,
  ucash: 1,
  cashbox: 2,
  external: 4,
  uplataInsha: 8,
  xpay: 16
}

export default {
  name: 'Withdraw',
  mixins: [formMixin, CurrencyRound],
  components: {SelectField, InputField, ConfirmWithdraw, SelectField2, SelectField3},
  data: _ => ({
    WITHDRAW_DIRECTION,
    limitList: [],
    directionList: [],
    form: {
      tokenCode: null,
      amount: '',
      withdrawal_type: '',
      direction: 0,
      wallets: {}
    },
    view: {
      mode: VIEW_MODES.submit,
      // mode: VIEW_MODES.success,
      opts: {}
    },
    minAmounts: {
      ETH: '0.01',
      UAH: '1.00'
    },
    maxAmounts: {
      BTC: '9999999999999999',
      ETH: '9999999999999999',
      UAH: '9999999999999999'
    },
    fixedFee: '',
    percentFee: '',
    allFees: {}, // получение установленной комиссии для определенной валюты
    allFeesLoaded: false, // признак получения установленной комиссии
    willCharged: '',
    isFeesLoadPending: false,
    isFeesLoadFailed: false,
    feesDebouncedRequest: null,
    remainder: false,
    defaultMinAmount: '10.00',
    commissionDescription: '',
    i18n,
    VIEW_MODES,
    ACCOUNT_TYPES,
    CRYPTO_CURRENCYS,
    colorTron: 'White',
    colorTronSwitch: false
    // subwallets: null,
    // activeSubWallet: null
  }),
  async created () {
    if (!this.isProductionEnv) {
      this.defaultMinAmount = '1.00'
    }

    this.reloadData()
    this.tokenCodes.forEach(el => {
      this.form.wallets[el] = ''
    })
  },
  computed: {
    ...mapGetters([
      vuexTypes.userWithdrawableTokens,
      vuexTypes.userCashTokens,
      vuexTypes.accountDepositAddresses,
      vuexTypes.accountBalances,
      vuexTypes.userTaurus,
      vuexTypes.userXpay,
      vuexTypes.userUplataInsha,
      vuexTypes.accountSignerName,
      vuexTypes.accountTypeI,
      vuexTypes.factorData,
      vuexTypes.accountId,
      vuexTypes.kfy,
      vuexTypes.walletId,
      vuexTypes.isProductionEnv
    ]),
    tokenCodes () {
      return this.userWithdrawableTokens.map(token => token.code).filter(el => !el.endsWith('20D'))
    },
    isTron () {
      // Historical name: "tron" here means any network token with a grey (D) counterpart
      return isNetworkToken(this.form.tokenCode)
    },
    greyTronValue () {
      if (isCryptoToken(this.form.tokenCode) && this.accountBalances[`${this.form.tokenCode}D`]) {
        return this.roundCurrency2(this.accountBalances[`${this.form.tokenCode}D`].balance)
      }
      return this.roundCurrency2(0)
    },
    swimAmount () {
      if (isCryptoToken(this.form.tokenCode)) {
        return this.roundCurrency2(this.form.amount, this.form.tokenCode)
      }
      return this.roundCurrency(this.form.amount, this.form.tokenCode)
    },
    swimBalance () {
      const row = this.accountBalances[this.form.tokenCode]
      if (isCryptoToken(this.form.tokenCode)) {
        return this.roundCurrency2(row !== undefined ? row.balance : 0)
      }
      return this.roundCurrency(row !== undefined ? row.balance : 0, this.form.tokenCode)
    },
    grayToken () {
      return this.colorTron === 'Gray' ? this.form.tokenCode + 'D' : this.form.tokenCode
    },
    tokensCodeFormatted () {
      if (this.tokenCodes) {
        return sortAssetCodes(this.tokenCodes).map(el => ({key: el, val: formatTokenCode(el)}))
      }
      return []
    },
    greyWhiteTronSum () {
      const white = this.accountBalances[this.form.tokenCode]
      const grey = this.accountBalances[`${this.form.tokenCode}D`]
      if (isCryptoToken(this.form.tokenCode) && white && grey) {
        return this.roundCurrency2(+white.balance + +grey.balance)
      }
      return this.roundCurrency2(white ? +white.balance : 0)
    },
    tokenCashCodes () {
      return this.userCashTokens.map(token => token.code)
    },
    balance () {
      let token = this.form.tokenCode
      if (this.isTron) {
        token = this.colorTron === 'Gray' ? this.form.tokenCode + 'D' : this.form.tokenCode
      }
      return this.accountBalances[token]
    },
    // subWalletBalance () {
    //   if (this.activeSubWallet) {
    //     return this.subWalletsFormated.find(el => el.WalletId === this.activeSubWallet)
    //   }
    //   return false
    // },
    isLimitExceeded () {
      return Number(this.form.amount) > Number(get(this.balance, 'balance') || 0)
    },
    isWithdrawLimitExceeded () {
      return this.form.amount !== '' ? Number(this.form.amount) > this.maxAmounts[this.form.tokenCode] : false
    },
    isTryingToSendToYourself () {
      return this.form.wallet === this.accountDepositAddresses[this.form.tokenCode]
    },
    lessThenMinimumAmount () {
      return this.hasMinAmount && this.form.amount !== '' ? Number(this.form.amount) < this.minAmount : false
    },
    hasMinAmount () {
      return this.minAmount !== null && this.minAmount !== undefined && this.minAmount !== ''
    },
    minAmount () {
      if (!limitsService.usesDefaultWithdrawalMinAmount(this.form.tokenCode)) {
        return this.minAmounts[this.form.tokenCode] || null
      }
      return this.minAmounts[this.form.tokenCode] ? this.minAmounts[this.form.tokenCode] : this.defaultMinAmount
    },
    commissions () {
      const name = this.accountSignerName
      return name ? name.toLowerCase().startsWith('commission', 0) : false
    },
    isAllowedToSubmit () {
      return !(this.isFeesLoadPending || this.isLimitExceeded || this.isWithdrawLimitExceeded ||
          this.isTryingToSendToYourself || this.lessThenMinimumAmount)
    },
    // subWalletsFormated () {
    //   if (this.subwallets) {
    //     return this.subwallets.filter(el => el.Asset === this.form.tokenCode)
    //   }
    //   return []
    // },
    formatToken () {
      return isNetworkToken(this.form.tokenCode) ? formatTokenCode(this.form.tokenCode) : this.assetIcon(this.form.tokenCode)
    }
  },
  methods: {
    isCryptoToken,
    ...mapActions({
      loadBalances: vuexTypes.GET_ACCOUNT_BALANCES,
      loadTaurus: vuexTypes.GET_USER_TAURUS,
      loadUplataInsha: vuexTypes.GET_USER_UPLATA_INSHA,
      loadXpay: vuexTypes.GET_USER_XPAY,
      updateTwoFactorData: vuexTypes.SET_TWO_FACTOR_STATE
    }),
    async checkLimit () {
      let token = this.form.tokenCode
      if (this.isTron) {
        token = this.colorTron === 'Gray' ? this.form.tokenCode + 'D' : this.form.tokenCode
      }
      const data = await usersService.getLimit(token, transactionType.withdrawal, this.getWithdravalType())
      this.limitList = data
    },
    checkAmount () {
      let token = this.form.tokenCode
      if (this.isTron) {
        token = this.colorTron === 'Gray' ? this.form.tokenCode + 'D' : this.form.tokenCode
      }
      if (isCryptoToken(this.form.tokenCode)) {
        this.form.amount = this.roundCurrency2(this.form.amount, token)
      } else {
        this.form.amount = this.roundCurrency(this.form.amount, token)
      }
    },
    // async getSubWallets () {
    //   const {_parsedData: res} = await withdrawUSDTService.getSubWallets({
    //     user_id: this.accountId
    //   })
    //   this.subwallets = res
    //   this.subwallets = this.subwallets.map(el => {
    //     return {
    //       ...el,
    //       Balance: el.Balance / 1000000
    //     }
    //   })
    // },
    async reloadData () {
      this.loadTaurus().then(() => {
        this.directionList = this.getDirections(WITHDRAW_DIRECTION.cashbox | WITHDRAW_DIRECTION.ucash | WITHDRAW_DIRECTION.uplataInsha | WITHDRAW_DIRECTION.xpay)
      }).catch(error => console.log(error))
      this.loadUplataInsha().then(() => {
        this.directionList = this.getDirections(WITHDRAW_DIRECTION.cashbox | WITHDRAW_DIRECTION.ucash | WITHDRAW_DIRECTION.uplataInsha | WITHDRAW_DIRECTION.xpay)
      }).catch(error => console.log(error))
      this.loadXpay().then(() => {
        this.directionList = this.getDirections(WITHDRAW_DIRECTION.cashbox | WITHDRAW_DIRECTION.ucash | WITHDRAW_DIRECTION.uplataInsha | WITHDRAW_DIRECTION.xpay)
      }).catch(error => console.log(error))
      await this.loadBalances()
      // await this.getSubWallets()
      const idx = this.tokenCodes.indexOf('UAH')
      this.form.tokenCode = this.tokenCodes[idx !== -1 && idx < this.tokenCodes.length ? idx : 0] || null
      let token = this.form.tokenCode
      if (this.isTron) {
        token = this.colorTron === 'Gray' ? this.form.tokenCode + 'D' : this.form.tokenCode
      }
      this.setDefaultDirection(token)
    },
    isCashable () {
      return (this.userCashTokens.map(token => token.code)).includes(this.form.tokenCode)
    },
    async submit () {
      if (!this.isAllowedToSubmit) return
      this.disableLong()

      try {
        if (this.isFeesLoadFailed) {
          EventDispatcher.dispatchShowErrorEvent('Failed to load fees')
          return false
        }
        const options = this.composeOptions()
        await withdrawService.createWithdrawalRequest(options)
        EventDispatcher.dispatchShowErrorEvent(i18n.withdraw_usdt_delay_msg())

        this.view.mode = VIEW_MODES.success
        await this.loadBalances()
      } catch (error) {
        if (error instanceof errors.TFAExceededCodeError) {
          EventDispatcher.dispatchShowErrorEvent(i18n.tfa_to_many_attempts())
        } else {
          ErrorHandler.processUnexpected(error)
        }
      }

      this.enable()
      this.errors.clear()
    },
    async setTronWhite () {
      this.colorTron = 'White'
      this.allFeesLoaded = false
      await this.loadSelectedAssetMinAmount(this.form.tokenCode)
      this.setDescription()
      await this.checkLimit()
      this.tryGetFees()
    },
    async setTronGray () {
      this.colorTron = 'Gray'
      this.allFeesLoaded = false
      await this.loadSelectedAssetMinAmount(this.form.tokenCode)
      this.setDescription()
      await this.checkLimit()
      this.tryGetFees()
    },
    async loadSelectedAssetMinAmount (asset) {
      const minAmount = await limitsService.loadWithdrawalMinAmount(asset)
      if (minAmount) this.$set(this.minAmounts, asset, minAmount)
    },
    addressRuleFor,
    assetIcon (asset) {
      return CurrencyHelper.getCurrencyIcon(asset)
    },
    async processTransfer () {
      if (!this.isAllowedToSubmit) return
      if (!await this.isValid()) return
      this.disable()
      try {
        const opts = await this.composeOptions()
        this.updateView(VIEW_MODES.confirm, opts)
      } catch (error) {
        console.log(error)
        if (error instanceof errors.NotFoundError) {
          error.showBanner(i18n.withdraw_error_invalid_address())
          this.enable()
          return
        }
        ErrorHandler.processUnexpected(error)
      }
      this.enable()
    },
    composeOptions () {
      const internalId = crypto.randomUUID()
      const withdravalType = this.getWithdravalType()
      const sub = this.subWalletBalance
      let token = this.form.tokenCode
      if (this.isTron) {
        token = this.colorTron === 'Gray' ? this.form.tokenCode + 'D' : this.form.tokenCode
      }

      const data = {
        balance: this.balance.balance_id,
        sender_user_id: this.accountId,
        receiver_account: this.form.wallets[token],
        sub_wallet_id: sub ? sub.WalletId : null,
        externalDetails: {
          address: this.form.wallets[this.form.tokenCode],
          withdrawalType: withdravalType,
          displayName: this.form.direction,
          internalId: internalId,
          wallet: this.walletId
        },
        destAsset: token,
        fee: {
          fixed: this.fixedFee,
          percent: this.percentFee
        }
      }
      if (isCryptoToken(this.form.tokenCode)) {
        data.amount = this.roundCurrency2(this.form.amount, this.form.tokenCode)
        data.expectedDestAssetAmount = this.roundCurrency2(this.form.amount, this.form.tokenCode)
      } else {
        data.amount = this.roundCurrency(this.form.amount, this.form.tokenCode)
        data.expectedDestAssetAmount = this.roundCurrency(this.form.amount, this.form.tokenCode)
      }
      return data
    },
    getDirections (ids) {
      let dirs = []
      if ((ids & this.WITHDRAW_DIRECTION.ucash) === this.WITHDRAW_DIRECTION.ucash) {
        this.userTaurus.forEach(taid => {
          dirs.push(i18n.withdraw_ucash({taid: taid.id}))
        })
      }

      if ((ids & this.WITHDRAW_DIRECTION.uplataInsha) === this.WITHDRAW_DIRECTION.uplataInsha) {
        this.userUplataInsha.forEach(uplata => {
          dirs.push(i18n.withdraw_uplata_insha({uplataInsha: uplata.id}))
        })
      }
      if ((ids & this.WITHDRAW_DIRECTION.xpay) === this.WITHDRAW_DIRECTION.xpay) {
        this.userXpay.forEach(xpay => {
          if (xpay.pi_type_id !== XPAY_NON_VISIBLE_TYPE) {
            dirs.push(i18n.withdraw_xpay({
              name: xpay.name,
              mask_pan: xpay.mask_pan
            }))
          }
        })
      }
      if ((ids & this.WITHDRAW_DIRECTION.cashbox) === this.WITHDRAW_DIRECTION.cashbox) {
        dirs.push(i18n.withdraw_cashbox())
      }
      if ((ids & this.WITHDRAW_DIRECTION.external) === this.WITHDRAW_DIRECTION.external) {
        dirs.push(i18n.withdraw_external({asset: this.formatToken}))
      }
      if (!dirs.length) {
        dirs.push(i18n.withdraw_nothere())
      }
      return dirs.length === 1 ? dirs[0] : dirs
    },
    directionOf (direction, value) {
      const dir = this.getDirections(direction)
      let idx = -1
      if (!Array.isArray(dir) && value === dir) {
        idx = 0
      } else if (Array.isArray(dir)) {
        idx = dir.indexOf(value)
      }
      return idx
    },
    async getFees () {
      let token = this.form.tokenCode
      if (this.isTron) {
        token = this.colorTron === 'Gray' ? token + 'D' : token
      }
      try {
        const fees = await feeService.loadWithdrawalFeeByAmount(token, this.form.amount)
        this.fixedFee = this.commissions ? 0 : Number(fees.fixed).toFixed(DECIMAL_PLACES)
        this.percentFee = this.commissions ? 0 : Number(fees.percent).toFixed(DECIMAL_PLACES)
        this.isFeesLoadFailed = false
      } catch (err) {
        this.isFeesLoadFailed = true
        EventDispatcher.dispatchShowErrorEvent(i18n.fees_load_fail())
      }
      this.isFeesLoadPending = false
      this.willCharged = this.roundCurrency((parseFloat(this.fixedFee) + parseFloat(this.percentFee) + parseFloat(this.form.amount)).toFixed(DECIMAL_PLACES), token, false)
      if (!this.allFeesLoaded) {
        try {
          const getAllFees = await feeService.loadAccountFees()
          Object.values(getAllFees)
              .forEach(fees => fees.forEach(fee => {
                if (fee.asset === token && fee.fee_type === 2) {
                  this.allFees = {
                    percent: Number(fee.percent).toFixed(DECIMAL_PLACES),
                    fixed: Number(fee.fixed).toFixed(DECIMAL_PLACES)
                  }
                }
              }))
          this.allFeesLoaded = true
        } catch (error) {
          console.error(error)
        }
      }
    },
    tryGetFees () {
      if (this.accountTypeI === this.ACCOUNT_TYPES.commission) return
      this.isFeesLoadPending = true
      if (!this.feesDebouncedRequest) {
        this.feesDebouncedRequest = debounce(() => this.getFees(), 300)
      }
      return this.feesDebouncedRequest()
    },

    async updateView (mode, opts = {}, clear = false) {
      this.view.mode = mode
      this.view.opts = opts
      if (clear) {
        this.clear()
        this.setTokenCode()
        this.reloadData()
      }
    },
    setTokenCode () {
      // Route params are untrusted: accept only tokens the user actually holds
      const routeToken = this.$route.params.tokenCode
      this.form.tokenCode = (this.tokenCodes.includes(routeToken) ? routeToken : null) ||
        this.tokenCodes[0] || null
    },
    setDefaultDirection (code) {
      let dir = this.WITHDRAW_DIRECTION.nothere
      if (code === 'UAHX') {
        // eslint-disable-next-line no-unused-vars
        dir = this.getDirections(this.WITHDRAW_DIRECTION.cashbox)
      } else {
        dir = this.getDirections(code === 'UAH' && this.userTaurus.length > 0
            ? this.WITHDRAW_DIRECTION.ucash
            : (code === 'UAH' && this.userUplataInsha.length > 0
                ? this.WITHDRAW_DIRECTION.uplataInsha
                : (this.isCashable()
                    ? this.WITHDRAW_DIRECTION.cashbox
                    : this.WITHDRAW_DIRECTION.nothere)))
      }
      this.form.direction = Array.isArray(dir) ? dir[0] : dir
    },
    setDescription () {
      if (!this.hasMinAmount) {
        this.commissionDescription = ''
        return
      }

      this.commissionDescription = i18n.withdraw_how_much({
        asset: this.formatToken,
        value: this.minAmount
      })
    },
    getWithdravalType () {
      let withdravalType = ''
      if (this.directionOf(this.WITHDRAW_DIRECTION.ucash, this.form.direction) !== -1) {
        withdravalType = 'taid'
      } else if (this.directionOf(this.WITHDRAW_DIRECTION.uplataInsha, this.form.direction) !== -1) {
        withdravalType = 'uplata%20insha'
      } else if (this.directionOf(this.WITHDRAW_DIRECTION.xpay, this.form.direction) !== -1) {
        withdravalType = 'xpay'
      } else if (this.form.tokenCode === CRYPTO_CURRENCYS.BTC) {
        // BTC payouts go through the usdt_listener pipeline (asset BTC); the
        // legacy 'btc' type routed to the retired btcwallet contour
        withdravalType = 'usdt'
      } else if (this.form.tokenCode === CRYPTO_CURRENCYS.ETH) {
        withdravalType = 'ETH'
      } else if (getTokenNetwork(this.form.tokenCode)) {
        // Any network token (grey included) goes through the usdt withdrawal pipeline
        withdravalType = 'usdt'
      }
      return withdravalType
    },
    setRoundDescription () {
      this.remainder = false
      if (this.form.amount.split('.').length > 1) {
        if (this.getWithdravalType() !== '' || this.form.amount.split('.')[1].length > 2) {
          this.remainder = true
        }
      }
    },
    isFeesCharged () {
      const minAmount = this.hasMinAmount ? parseFloat(this.minAmount) : 0
      return parseFloat(this.form.amount) >= minAmount && !this.isLimitExceeded && this.willCharged > 0
    },
    nonVisibleXpay () {
      return this.userXpay.length === 1 && this.userXpay[0].pi_type_id === XPAY_NON_VISIBLE_TYPE
    }
  },
  watch: {
    colorTronSwitch (value) {
      if (!value) {
        this.setTronWhite()
      } else {
        this.setTronGray()
      }
    },
    'form.amount' (value) {
      if (this.isLimitExceeded || !+this.form.amount) return

      if (value === '' || (this.hasMinAmount && +value < +this.minAmount)) {
        this.fixedFee = '0.00'
        this.percentFee = '0.00'
        return
      }
      this.tryGetFees()
      this.setRoundDescription()
    },
    async 'form.tokenCode' (value) {
      this.form.wallets = {}
      this.tokenCodes.forEach(el => {
        this.form.wallets[el] = ''
      })

      await this.loadSelectedAssetMinAmount(value)
      this.setDescription()
      this.activeSubWallet = null
      if (!+this.form.amount) return

      this.allFeesLoaded = false
      this.tryGetFees()
      this.setDefaultDirection(value)
    },
    'form.direction' (value) {
      let idx = -1
      if ((idx = this.directionOf(this.WITHDRAW_DIRECTION.ucash, value)) !== -1) {
        this.form.wallet = this.userTaurus[idx].id
      } else if ((idx = this.directionOf(this.WITHDRAW_DIRECTION.uplataInsha, value)) !== -1) {
        this.form.wallet = this.userUplataInsha[idx].id
      } else if ((idx = this.directionOf(this.WITHDRAW_DIRECTION.xpay, value)) !== -1) {
        this.form.wallet = this.userXpay[idx].cc_uuid
      } else if (this.directionOf(this.WITHDRAW_DIRECTION.external, value) === -1) {
        this.form.wallet = ''
      }
      this.setRoundDescription()
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~scss/variables';
@import '~scss/mixins';
.bold {
    font-weight: bold;
  }
.swticher-tron {
  display: flex;
  gap: 10px;
  align-items: center;
}
.active {
  background-color: rgba($carbon-black, 0.2);
}
.w-100 {
  width: 100%;
}
.danger {
  color: #B11D1D;
  display: block;
  margin-bottom: 16px;
}

.withdraw__user-balance {
  margin-bottom: 24px;
  color: $default-black;
}

.withdraw__explanations {
  margin-bottom: 24px;
  line-height: 28px;
}

.withdraw__flex-wrapper {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
}

.withdraw__select,
.withdraw__field {
  width: 47%;
  flex: none;
}

.withdraw__field {
  position: relative;
}

.withdraw__fees-container {
  color: $default-black;

  &.loading {
    opacity: .7;
  }

  .fee__fee-type {
    color: $col-active;
  }
}
.md-switch {
  margin: 0;
}
.withdraw__fee-error {
  position: absolute;
  right: -60%;
}

.md-field.md-theme-default.md-invalid.md-focused label {
  border-color: $col-invalid;
}

.withdraw__success-msg {
  text-align: center;
}

.withdraw__success-amount {
  color: $default-black;
  font-size: 22px;
  margin: 1rem 0 .5rem;
}
.grey {
  background-color: $gray_asset !important;
}
/deep/ .md-field.grey label  {

  background-color: $gray_asset !important;

}


</style>



// WEBPACK FOOTER //
// src/vue/app/withdrawal/make/Withdrawal.Make.vue